import React from 'react';

import useScreen from '@lyearn/core/hooks/useScreen';
import { cn } from '@lyearn/style';
import * as BaseCard from '@/modules/content/components/ContentCard/BaseCard';
import { COMMON_CARD_CLASSNAME } from '@/modules/content/components/ContentCard/styles';

import { defaultCardSizeStyles } from './styles';

const DefaultCard: React.FC<BaseCard.BaseCardProps> = (props) => {
  const { children, content, className, overrideDefaultStyle, ...rest } = props;
  const { isMobile } = useScreen();

  return (
    <BaseCard.Provider
      className={cn(
        COMMON_CARD_CLASSNAME,
        overrideDefaultStyle || defaultCardSizeStyles,
        className,
      )}
      content={content}
      direction="col"
      {...rest}>
      {!props.disabled ? <BaseCard.Bookmark /> : null}
      {children}
    </BaseCard.Provider>
  );
};

export default DefaultCard;
